var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"grid-wrapper"},[_vm._l((_vm.searchingData),function(item){return _vm._t("default",null,{"props":item})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }